import { Pagination, RootState } from "src/shared/types/src";   

export const getPostsLoading = (state: RootState) => state?.eyengage?.isLoading || false;

export const getPostsPaginatedLoading = (state: RootState) => state?.eyengage?.paginatedLoading || false;

export const getPostsPagination = (state: RootState) => state?.eyengage?.pagination || {} as Pagination;

export const getPostsCurrentPage = (state: RootState) => state?.eyengage?.pagination?.currentPage || 1;

export const getPostsLastPage = (state: RootState) => state?.eyengage?.pagination?.lastPage || 1;

export const getPostsTotalItems = (state: RootState) => state?.eyengage?.pagination?.totalItems || 0;

export const getPostsData = (state: RootState) => state?.eyengage?.posts || [];

export const getParentPermissionOnEyengage = (state: RootState) => state?.eyengage?.settings?.permission;

export const getEyengageFilterCategories = (state: RootState) => state?.eyengage?.filterCategories || [];

export const getIsEyengageFilterApplied = (state: RootState) => state?.eyengage?.isEyengageFilterApplied || false;

export const getSelectedPostTypeFilter = (state: RootState) => state?.eyengage?.selectedPostTypeFilter || [];

export const getSelectedCategoryFilter = (state: RootState) => state?.eyengage?.selectedCategoryFilter || {};

export const getEyManSettingsLoading = (state: RootState) => state?.eyengage?.eyManSettingsLoading || false;